import React, { lazy } from 'react';
import { RouteConfig } from 'react-router-config';
import IconBugly from '@/assets/images/menu/icon-bugly.react.svg?react';
import { MenuIcon } from '@/presentation/components/menu-icon';

export const webCrashRoutes = (): RouteConfig[] => [
  {
    path: '/exception/web-crash',
    name: '崩溃',
    icon: <MenuIcon icon={IconBugly} fontSize={16} />,
    routes: [
      {
        path: '/exception/web-crash/dashboard',
        name: '概览',
        component: lazy(() => import('@/presentation/pages/web/crash/dashboard')),
      },
      {
        path: '/exception/web-crash/issues/list',
        name: '问题列表',
        component: lazy(() => import('@/presentation/pages/web/crash/issues/list')),
      },
      {
        path: '/exception/web-crash/issues/detail',
        name: '问题详情',
        component: lazy(() => import('@/presentation/pages/web/crash/issues/detail')),
        hideInMenu: true,
        whitelisted: true,
      },
      {
        path: '/exception/web-crash/caller/detail',
        name: '调用方详情',
        component: lazy(() => import('@/presentation/pages/web/crash/caller-detail')),
        hideInMenu: true,
        whitelisted: true,
      },
    ],
  },
];
